import {InputGroup} from "@blueprintjs/core";
import {observer} from "mobx-react";
import React from "react";

import {STRING_TYPE} from "../../../stores/database-template/database-form-base";
import {TableRecord} from "../../../stores/database-template/database-record-base-store";
import {SettingIconButton} from "../../atoms/buttons/buttons";
import {FillTextArea} from "../../atoms/inputs/fill-textarea";
import {FlexGapContainer} from "../../atoms/layouts/category-layout-containers";
import {Td, Tr} from "../../atoms/tables/table";
import {TemplateDetailImageUploadButton} from "../template-detail-image-upload-button/template-detail-image-upload-button";
import {UploadImageResult} from "../template-detail-image-upload-input/template-detail-upload-image";

interface Props {
    row: TableRecord;
    values: Record<string, string>;
    setValue: (rowId: string, value: string) => void;
    onImageUploaded: (uploadImageResult: UploadImageResult) => void;
    openOptions: (id: string) => void;
}

const DatabaseRecordRow: React.FC<Props> = observer(
    ({row, values, setValue, onImageUploaded, openOptions}) => (
        <Tr key={row.id}>
            <Td>{row.label}</Td>
            <Td>{row.type === STRING_TYPE ? "STRING" : "IMAGE"}</Td>
            <Td>
                {row.type === STRING_TYPE ? (
                    <FillTextArea
                        placeholder={`${row.label}を入力`}
                        value={values[row.id] ?? ""}
                        onChange={(e) => setValue(row.id, e.currentTarget.value)}
                    />
                ) : (
                    <FlexGapContainer>
                        <InputGroup
                            placeholder="画像パスを入力"
                            fill
                            value={values[row.id] ?? ""}
                            onChange={(e) => setValue(row.id, e.currentTarget.value)}
                        />
                        <TemplateDetailImageUploadButton
                            fieldId={row.id}
                            onUploaded={onImageUploaded}
                        />
                    </FlexGapContainer>
                )}
            </Td>
            <Td style={{textAlign: "center"}}>
                <SettingIconButton
                    disabled={row.type === STRING_TYPE}
                    onClick={() => openOptions(row.id)}
                />
            </Td>
        </Tr>
    ),
);

export default DatabaseRecordRow;
